import _ from 'lodash';
import * as RequestResultCases from 'middlewares/api-middleware';
import { SEARCH_SMART_COMMS_JOURNEY } from 'omega-rtc/actions/debugging-tools';

type DebuggingToolsState = {
  journeyResults: any[];
  hasSearched: boolean;
  totalCount: number;
};

const defaultDebuggingToolsState: DebuggingToolsState = {
  journeyResults: [],
  hasSearched: false,
  totalCount: 0,
};

const debuggingToolsReducer = (
  state: DebuggingToolsState = defaultDebuggingToolsState,
  action: any,
): DebuggingToolsState => {
  switch (action.type) {
    case SEARCH_SMART_COMMS_JOURNEY + RequestResultCases.SUCCESS:
      return {
        ...state,
        journeyResults: _.get(action.payload, 'records', []),
        totalCount: _.get(action.payload, 'totalCount', 0),
        hasSearched: true,
      };
    case SEARCH_SMART_COMMS_JOURNEY + RequestResultCases.FAILURE:
      return {
        ...state,
        journeyResults: [],
        totalCount: 0,
        hasSearched: true,
      };
    default:
      return state;
  }
};

export default debuggingToolsReducer;
